import React, { useContext, useState } from 'react';
import {
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';

import {
  Delete,
  SupervisorAccount,
  Person,
} from '@material-ui/icons';

import PropTypes from 'prop-types';

import AlertDialog from '../modals/alertDialog';
import SpinnerLoading from '../feedback/spinnerLoading';

import { removeClinician } from '../../utils/comms';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function MemberInfo({ handleMakeAdmin, handleFeedback, idEnrolment, memberData, programAdministratorIds, teamAdministrator, userType }) {
  const sessionContext = useContext(SessionContext);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const deleteMember = async () => {
    setShowLoading(true);
    const response = await removeClinician(idEnrolment, memberData._id, sessionContext.userToken);
    setShowLoading(false);
    if (response.status === 200) { // Membre eliminat
      handleFeedback('success', 'DeleteClinicianFromEnrolmentTeam', true);
    } else if (response === 'timeOut') { // El servidor està caigut o l'usuari no té connexió
      handleFeedback('error', 'TimeOut');
    } else if (response === 400) { // No es pot eliminar perquè és administrador del programa
      handleFeedback('error', 'DeleteClinicianFromEnrolmentTeamNotAllowedIsAdmin', false);
    } else if (response === 409) { // No es pot eliminar perquè és l'únic supervisor de l'equip del programa
      handleFeedback('error', 'DeleteClinicianFromEnrolmentTeamNotAllowedIsLastSupervisor', false);
    } else { // Altres tipus d'error
      handleFeedback('error', 'DeleteClinicianFromEnrolmentTeam', false);
    }
  };

  const manageDeleteAlertAnswer = (agree) => {
    setShowDeleteAlert(false);
    if (agree) deleteMember();
  };

  const isProgramAdministrator = () => {
    const isPAdmin = programAdministratorIds.find((administratorId) => administratorId.clinician._id === memberData._id);
    if (isPAdmin) return true;
    return false;
  };

  return (
    <React.Fragment>
      <SpinnerLoading show={showLoading} />
      <AlertDialog open={showDeleteAlert} handleClose={(agree) => manageDeleteAlertAnswer(agree)} title={translations['_deleteMemberAlertTitle']} message={translations['_deleteMemberAlertMessage']} data={[{ username: memberData.username }]} field='username' />
      <Grid container spacing={2} justify='flex-start' alignItems='center'>
        <Grid item xs={5}>
          <Typography variant='body1' component='span'>{memberData.username}</Typography>
        </Grid>
        <Grid item>
          <Grid container justify='flex-start' direction='row'>
            <Grid item>
              {/* <IconButton disabled={userType === 'Basic' || userType === 'Supervisor'} onClick={() => handleMakeAdmin(memberData._id, teamAdministrator)}>{teamAdministrator ? <SupervisorAccount /> : <Person />}</IconButton> */}
              {/* Si el clínic es de tipus bàsic no pot modificar el responsable de l'equip clínic */}
              {/* TODO: decidir què fer amb l'usuari AppAdmin (l'administrador del sistema) */}
              <IconButton disabled={userType === 'Basic'} onClick={() => handleMakeAdmin(memberData._id, teamAdministrator)}>{teamAdministrator ? <SupervisorAccount /> : <Person />}</IconButton>
            </Grid>
            <Grid item>
              {/* Si és el supervisor de l'equip o l'administrador del programa, no deixam que es pugui esborrar. Deshabilitam el botó d'esborrar */}
              {/* Si l'usuari clínic que accedeix a la interfície és l'usuari clínic bàsic, no té autorització per esborrar cap clínic de l'equip */}
              <IconButton onClick={() => setShowDeleteAlert(true)} disabled={teamAdministrator || isProgramAdministrator() || userType === 'Basic'}><Delete /></IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
MemberInfo.propTypes = {
  userType: PropTypes.string.isRequired,
  idEnrolment: PropTypes.string.isRequired,
  handleMakeAdmin: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  memberData: PropTypes.object.isRequired,
  programAdministratorIds: PropTypes.array.isRequired,
  teamAdministrator: PropTypes.bool.isRequired,
};
